import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing rational functions (shifted reciprocal form).
 * Focus: a/(x-h) + k with asymptote visualization.
 */
export const RATIONAL_PRESET: GraphpadWidgetConfig = {
  id: 'rational',
  type: 'graphpad',
  params: {
    f: {
      type: 'rational',
      params: { a: 1, h: 0, k: 0 },
    },
    'f-handle': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-asymptotes': {
      type: 'asymptotes',
      params: { of: 'f' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      f: { curve: { color: 'sky', strokeWidth: 3 } },
      'f-handle': { point: { color: 'sky', size: 8 } },
      'f-roots': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-5, 5, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'purple',
      },
      {
        id: 'slider-h',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'h (x-shift)',
        param: 'f.h',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-k',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'k (y-shift)',
        param: 'f.k',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
